<template>
  <div class="product-stores" :class="{ 'product-stores--embedded': embedded }">
    <template v-if="!embedded">
      <h5 class="font-weight-bold">فروشگاه های محصول</h5>
    </template>

    <div class="product-stores__search">
      <input
          type="text"
          class="form-control"
          v-model="searchedWord"
          placeholder="جستجوی فروشگاه"
          @keydown.enter.prevent="searchStores">
      <button type="button" class="product-stores__search-btn" @click="searchStores">
        جستجو
      </button>
    </div>

    <div class="product-stores__list">
      <button
          type="button"
          class="product-stores__item"
          v-for="store in stores"
          :key="store.id"
          @click="addStoreToProduct(store)">
        <span class="product-stores__dot" aria-hidden="true"></span>
        <span>{{ store.name }}</span>
      </button>
      <p class="product-stores__empty" v-if="!stores.length">فروشگاهی یافت نشد</p>
    </div>
  </div>
</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "ProductMultipleManager",
  props: {
    product: {},
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchedWord: '',
      stores: [],
    };
  },
  methods: {
    refreshStores() {
      this.searchedWord = ''
      this.$store.commit('MultipleStore/setFilters', {key: 'search', value: ''})
      this.loadStores()
    },
    loadStores() {
      let req = this.$store.dispatch('MultipleStore/getStoresWithoutState')
      req.then(res => {
        this.stores = res.data.data.data
      })
    },
    searchStores() {
      this.$store.commit('MultipleStore/setFilters', {key: 'search', value: this.searchedWord})
      this.loadStores()
    },
    deleteItem(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        let productStores = this.product.product_multiple_store
        let indexOfItem = productStores.map(row => row.id).indexOf(item.id)
        if (indexOfItem === -1) {
          indexOfItem = productStores.map(row => row.user && row.user.id).indexOf(item.user && item.user.id)
        }
        if (indexOfItem > -1) {
          productStores.splice(indexOfItem, 1)
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        }
      }
    },
    addStoreToProduct(item) {
      let productStores = this.product.product_multiple_store
      if (!Array.isArray(productStores)) {
        this.$set(this.product, 'product_multiple_store', [])
        productStores = this.product.product_multiple_store
      }

      if (productStores.map(row => row.user && row.user.id).indexOf(item.id) === -1) {
        productStores.push({user: item})
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      } else {
        toast('ایتم وجود دارد', 'این فروشگاه قبلاً اضافه شده است.', 'danger')
      }
    }
  },
  async mounted() {
    await this.loadStores()
  }
};
</script>

<style scoped>
.product-stores--embedded {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.product-stores__search {
  display: flex;
  gap: 0.45rem;
  margin-bottom: 0.65rem;
  position: sticky;
  top: 0;
  z-index: 1;
  padding-bottom: 0.35rem;
  background: #fff;
}

.product-stores__search .form-control {
  border-radius: 12px !important;
  border-color: rgba(30, 30, 30, 0.12) !important;
  background: #f7f7f8 !important;
}

.product-stores__search-btn {
  border: 0;
  border-radius: 12px;
  padding: 0 0.9rem;
  background: #424242;
  color: #fff;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.product-stores__list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  border-radius: 14px;
  border: 1px solid rgba(30, 30, 30, 0.08);
  background: #f5f5f6;
}

.product-stores__item {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  width: 100%;
  padding: 0.7rem 0.85rem;
  border: 0;
  border-bottom: 1px solid rgba(30, 30, 30, 0.06);
  background: transparent;
  color: #2a2a2a;
  text-align: right;
  font-weight: 600;
  cursor: pointer;
}

.product-stores__item:last-child {
  border-bottom: 0;
}

.product-stores__item:hover {
  background: rgba(235, 61, 96, 0.1);
  color: #d12d50;
}

.product-stores__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #eb3d60;
  flex: 0 0 auto;
}

.product-stores__empty {
  margin: 1rem;
  color: #8a8a8a;
  text-align: center;
}
</style>
